import React from "react";
import { Box, Typography } from "@mui/material";

const totalImages = 26;

const captionsMap = {
  0: "A baby’s first smash cake moment.",
  1: "A heartfelt retirement celebration.",
  2: "Setting the stage for forever.",
  3: "Unboxing a surprise treat from afar.",
  4: "A cozy night made sweeter.",
  5: "A last-minute birthday surprise.",
  6: "Celebrating love with cake.",
  7: "A little one’s first bite.",
  8: "Milestone achieved with sweetness.",
  9: "Family gathering centerpiece.",
  // Add more if desired
};

const moments = Array.from({ length: totalImages }, (_, index) => ({
  image: `/images/our_customers/customer-image-${index}.jpg`,
  caption: captionsMap[index] || `Featured moment #${index + 1}`,
  rotate: (Math.random() - 0.5) * 10,
}));

const FeaturedMoments = () => {
  return (
    <Box sx={{ py: 10 }}>
      <Typography
        variant="h3"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
        sx={{ fontFamily: "Moul" }}>
        Featured Moments
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        sx={{ mb: 6, maxWidth: 700, mx: "auto", color: "#707070" }}>
        You’ve let us into your birthdays, your weddings, your quiet evenings
        and your big days. These are just a few of the stories we've been
        honored to sweeten.
      </Typography>

      <Box
        sx={{
          overflow: "hidden",
          width: "100%",
          maxWidth: "100%",
          position: "relative",
          whiteSpace: "nowrap",
          backgroundColor: "#fff",
        }}>
        <Box
          sx={{
            display: "inline-flex",
            animation: "scrollLeft 120s linear infinite",
            "@keyframes scrollLeft": {
              from: { transform: "translateX(0%)" },
              to: { transform: `translateX(-50%)` },
            },
          }}>
          {/* Duplicate the images to create seamless loop */}
          {moments.concat(moments).map((moment, index) => (
            <Box
              key={index}
              sx={{
                display: "inline-block",
                width: 300,
                marginRight: 4,
                position: "relative",
                boxShadow: 3,
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
              }}>
              <img
                src={moment.image}
                alt={moment.caption}
                style={{ width: "100%", height: 350, objectFit: "cover" }}
              />
              {/* <Box
                sx={{
                  p: 1,
                  fontSize: "0.8rem",
                  textAlign: "center",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  position: "absolute",
                  bottom: 0,
                  width: "100%",
                }}>
                {moment.caption}
              </Box> */}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default FeaturedMoments;
